module.exports = __webpack_public_path__ + "img/v5-member.61468c65.png";